// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__23hla","right":"Footer_right__1UVsC","buttons":"Footer_buttons__2h3-T"};